import { type Domain, domains } from '@config'
import { useLocation } from '@reach/router'
import { useIsSSR } from '@react-aria/ssr'
import { useMemo } from 'react'

const productionDomains = Object.values(domains).map(
  (domain) => domain.production
)

export const useDomainUrl = (domainId: Domain) => {
  const { origin } = useLocation()
  const isSSR = useIsSSR()

  return useMemo(() => {
    const isProduction = isSSR || productionDomains.includes(origin)
    const { production, staging } = domains[domainId]
    return isProduction ? production : staging
  }, [origin, isSSR])
}
